import React, {useEffect, useReducer, useState} from 'react'
import {useNavigate} from "react-router-dom";
import {useTusJsClient} from "../hooks";
import {FileIcon, FolderIcon} from "../widgets/Icons";
import Link from "../widgets/Link";
import {useApi} from "../ApiSession";


function humanFileSize(b) {
    var u = 0, s=1024;
    while (b >= s || -b >= s) {
        b /= s;
        u++;
    }
    return (u ? b.toFixed(1) + ' ' : b) + ' KMGTPEZY'[u] + 'B';
}

const fileSelectionReducer = (state, action) => {

    switch (action.name) {
        case "select":
            return {
                ...state,
                [action.fileName]: true
            }
        case "unselect":
            return {
                ...state,
                [action.fileName]: false
            }
        case "unselectAll":
            return {}
        default:
            throw Error(`unknown action ${action.name}`)
    }
}


const FileManager = ({pipelineInstanceDir}) => {

    const [files, setFiles] = useState(null)

    const [refreshCounter, refreshCounterDispatch] = useReducer(c => c + 1, 0)

    const [fileSelection, fileSelectionDispatcher] = useReducer(fileSelectionReducer, {})

    const navigate = useNavigate()

    const api = useApi()

    const {
        uploadInput,
        isInProgress,
        isComplete,
        bytesTotal,
        bytesUploaded,
        percentage,
        error,
        fileName,
        clickUpload
    } = useTusJsClient({
        endpoint: `/files`,
        path: pipelineInstanceDir,
        onSuccess: refreshCounterDispatch
    })

    useEffect(() => {
        api.getPipelineFiles(pipelineInstanceDir).then(setFiles)
    }, [`${refreshCounter}`]);

    const progressBar = () => <>
            <div className="flex justify-between mb-1">
                <span className="text-base font-medium text-blue-700 dark:text-white">{fileName}</span>
                <span className="text-sm font-medium text-blue-700 dark:text-white">{percentage}</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                <div className="bg-blue-600 h-2.5 rounded-full" style={{width: `${percentage}%`}}></div>
            </div>
        </>


    return <div className="overflow-x-auto shadow-md sm:rounded-lg">

        <pre className={"m-6 text-lg font-bold"}>{pipelineInstanceDir}</pre>
        {isInProgress && progressBar()}
        <div className="m-2 flex justify-center">
            <div>
                <input ref={uploadInput} type="file" multiple={true} style={{display: 'none'}}/>
                <button
                    type="button"
                    className="text-blue-700 border border-blue-700 hover:bg-blue-700 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center me-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:focus:ring-blue-800 dark:hover:bg-blue-500"
                    onClick={() => {
                        api.deletePipelineFiles(pipelineInstanceDir, {fileNames: Object.keys(fileSelection)}).then(() => {
                            refreshCounterDispatch()
                            fileSelectionDispatcher({name: "unselectAll"})
                        })
                    }}
                >
                    <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                         xmlns="http://www.w3.org/2000/svg"
                         width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                              d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"/>
                    </svg>
                    <span>Delete Selected</span>
                </button>
            </div>
            <div>
                <button type="button"
                        onClick={clickUpload}
                        className="text-blue-700 border border-blue-700 hover:bg-blue-700 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center me-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:focus:ring-blue-800 dark:hover:bg-blue-500"
                >
                    <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                         xmlns="http://www.w3.org/2000/svg"
                         width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                              d="M12 5v9m-5 0H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2M8 9l4-5 4 5m1 8h.01"/>
                    </svg>
                    <span>Upload File</span>
                </button>
            </div>
        </div>
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
                <th></th>
                <th>name</th>
                <th></th>
                <th>size</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            {
                (!files) ? null :
                    files.map(p =>

                        <tr key={p.name}
                            className="cursor-default bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600"
                        >
                            <td className="w-4 p-4">
                                <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                        value={fileSelection[p.name]}
                                        onChange={
                                            () => fileSelection[p.name] ?
                                                fileSelectionDispatcher({name: "select", fileName: p.name}) :
                                                fileSelectionDispatcher({name: "unselect", fileName: p.name})
                                        }
                                    />
                                </div>
                            </td>
                            <td>
                                {p.type === "f" && <FileIcon/>}
                                {p.type === "d" && <FolderIcon/>}
                            </td>
                            <th scope="row"
                                className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                <span>{p.name}</span>
                            </th>
                            <td className="px-6 py-4">
                                {p.type === "f" ? humanFileSize(p.size) : ""}
                            </td>
                            <td>
                                <Link
                                        href={`/api/downloadPipelineFile${pipelineInstanceDir}/${p.name}`}
                                        target={"_blank"}
                                    >
                                    <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 13V4M7 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2m-1-5-4 5-4-5m9 8h.01"/>
                                    </svg>
                                    </Link>
                            </td>
                        </tr>
                    )
            }
            </tbody>
        </table>
    </div>
}


export default FileManager